/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".hd--user-information-list[_ngcontent-%COMP%]{list-style-type:none}.hd--user-information-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{float:left}"];
export { styles as styles };
